import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'label'];

  copy(event) {
    event.preventDefault();
    this.inputTarget.select();
    document.execCommand('copy');
    const label = this.labelTarget;
    const oldLabel = label.innerHTML;
    label.innerHTML = 'Skopiowano!';
    Siepomaga.timeout(1000, () => {
      label.innerHTML = oldLabel;
    });
  }
}
